import { Injectable } from '@angular/core';
import { PartnerApplicationFillPropertiesMap } from '../../../../coverpath-common/js/interfaces/CoverpathTypes';
import { ApplicationService } from '../../../../coverpath-common/angular/services/application/application.service';

@Injectable()
export class PartnerApplicationFillService {
  partnerPropertiesMap: PartnerApplicationFillPropertiesMap;

  constructor(private applicationService: ApplicationService) {}

  setApplicationPropertiesMap() {
    const partnerPrefillDataObject = this.applicationService.appState.controller.partnerPrefillDataObject;
    if (partnerPrefillDataObject && partnerPrefillDataObject.applicationData) {
      const applicationData = partnerPrefillDataObject.applicationData;
      const insured = applicationData.insured;
      const owner = applicationData.owner;
      this.partnerPropertiesMap = {
        'customer.application.primaryPolicy.insured.person.middleName': insured && insured.middleName,
        'customer.application.primaryPolicy.insured.person.SSN': insured && insured.taxId,
        'customer.application.primaryPolicy.insured.phone.number': insured && insured.phone,
        'customer.application.primaryPolicy.insured.person.email': insured && insured.email,
        'customer.application.primaryPolicy.ownerPerson.middleName': owner && owner.middleName,
        'customer.application.primaryPolicy.ownerPerson.SSN': owner && owner.taxId,
        'customer.application.primaryPolicy.ownerPersonPhone.number': owner && owner.phone,
        'customer.application.primaryPolicy.ownerPersonResidentialAddress.state':
          owner && owner.address && owner.address.state,
      };
    }
  }
}
